// completed using Vince's Demo recording.
import useMagicLink from "use-magic-link";

export default function useAuth() {
    return useMagicLink("pk_test_7892E9CCA21AFF6C");
}